import Modal from "../../components/Base/Modal";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useForm, SubmitHandler } from "react-hook-form"; // Import useForm and SubmitHandler
import LoadingSpinner from "../../components/LoadingSpinner";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorViewer from "../../components/ErrorViewer";
import Required from "../../components/Required";
import { EmployerinformationI } from "../../interfaces";
import {
  EmployerConfirmation,
  GetAllEmployerBranch,
  UpdateEmployerDetails,
} from "../../redux/selfService/selfServiceSlice";

interface ConfirmationModalProps {
  showModal: boolean;
  onClose: () => void;
  onProceed: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  showModal,
  onClose,
  onProceed,
}) => {
  const { isLoading } = useAppSelector((state) => state?.selfService);
  const dispatch = useAppDispatch();

  const {
    handleSubmit, // Destructure handleSubmit from useForm
  } = useForm(); // Initialize the form using useForm

  useEffect(() => {});

  const onSubmit: SubmitHandler<any> = async (values, e) => {
    e.preventDefault();

    const updateAction = await dispatch(EmployerConfirmation());
    console.log(updateAction);
    if (
      updateAction?.type === "selfService/EmployerConfirmation/fulfilled" &&
      updateAction?.payload?.statusCode !== "00"
    ) {
      // && updateAction?.payload.statusCode === "00") {
      onProceed();
    } else {
      onClose();
    }
  };

  return (
    <Modal
      showModal={showModal}
      onClose={onClose}
      className="transaction-summary-modal rounded-full"
    >
      <div className="modal-body rounded-b-xl">
        <h2>Employer Confirmation?</h2>
        <br />
        <div className="form__group">
          <label htmlFor="branch" className="form__label">
            To confirm the employer, kindly tap on the proceed button.{" "}
            <Required />
          </label>
          <h3></h3>
        </div>
        <div className="flex justify-end">
          <button
            className="btn btn-text mr-6"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit(onSubmit)} // Use handleSubmit from useForm
          >
            {isLoading ? <LoadingSpinner /> : "Proceed"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
